/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";

import Select from "react-select";

import TextInput2 from "../../component/input/TextInput2";
import SelectInput2 from "../../component/input/SelectInput2";
import Button from "../../component/button/Button";
import { dynamicInputToolTipData, options } from "./userData";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";

const DynamicTopInput = ({
  values,
  onChange,
  currentUser,
  selectedValues,
  allLocations,
  getUserByWorkerId,
  handleSelectCategories
}) => {
  const toolTipRender = () => {
    return dynamicInputToolTipData.map((tipData, index) => (
      <Fragment key={index}>
        <ReactTooltip
          place="top"
          type="info"
          id={tipData.id}
          effect="solid"
        >
          {tipData.text}
        </ReactTooltip>
      </Fragment>
    ));
  };

  return (
    <div className="row">
      {toolTipRender()}
      <div className="col-3">
        <SelectInput2
          data-tip
          isLabeled={true}
          name="locationId"
          onChange={onChange}
          data-for="locationId"
          label="Select Location"
          value={values.locationId}
          placeholder="Select Location"
          icon="mdi mdi-map-marker-radius"
        >
          <option value="ALL">ALL</option>
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                locationRender(currentUser, false)
              )}
        </SelectInput2>
      </div>

      <div className="col-sm-3">
        <TextInput2
          data-tip
          type="text"
          name="workerId"
          onChange={onChange}
          data-for="workerId"
          value={values.workerId}
          icon="mdi mdi-table-search"
          placeholder="Search E-Code..."
        />
      </div>
      <div className="col-lg-4">
        <Select
          isMulti
          name="categories"
          options={options}
          classNamePrefix="select"
          defaultValue={selectedValues}
          className="basic-multi-select"
          onChange={handleSelectCategories}
        />
      </div>
      <div className="col-2">
        <Button
          data-tip
          title="Get"
          type="button"
          data-for="getButton"
          isBackgroundColor={false}
          onClick={getUserByWorkerId}
          icon="mdi mdi-database-plus mr-2"
          className="btn text-white btn-block btn-primary float-right"
        />
      </div>
    </div>
  );
};

DynamicTopInput.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  allLocations: PropTypes.array.isRequired,
  selectedValues: PropTypes.array.isRequired,
  getUserByWorkerId: PropTypes.func.isRequired,
  handleSelectCategories: PropTypes.func.isRequired
};

export default DynamicTopInput;
